import { render } from "./BRollRequestView.vue?vue&type=template&id=5e675d19&scoped=true&ts=true"
import script from "./BRollRequestView.vue?vue&type=script&lang=ts"
export * from "./BRollRequestView.vue?vue&type=script&lang=ts"

import "./BRollRequestView.vue?vue&type=style&index=0&id=5e675d19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e675d19"]])

export default __exports__